// import { identity } from 'lodash'
import { identity } from 'lodash'
import React from 'react'
import { Field as FFField } from 'react-final-form'

// here we override some of react-final-form default behaviour
export const Field = (props) => <FFField parse={identity} {...props} />
